import { Actions, modalHandler } from "@";

// Component for table actions
export const TableActions = ({ row, deleteHandler, setIsEdit, reset }) => {
  // Function to handle edit action
  const edit = (row) => {
    reset(row);
    setIsEdit(true);
    modalHandler();
  };

  return (
    <>
      {/* Actions component for row */}
      <Actions notShow row={row} edit={edit} delete={deleteHandler} />
    </>
  );
};

// Table columns configuration
export const tableColumns = [
  {
    name: "الاسم",
    selector: ({ name }) => name,
  },
  {
    name: "رقم الجوال",
    selector: ({ phone }) => phone,
  },
  {
    name: "البريد الالكتروني",
    selector: ({ email }) => email,
  },
];
